/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { WizardStep, WizardStepProps } from '@squiz/sds';
import React from 'react';
import { AddComponentToSetProps } from '../../AddComponentToSet.props';
import { AvailableComponentsForm } from '../../forms/AvailableComponentsForm/AvailableComponentsForm';
import { AvailableComponentsFormProps } from '../../forms/AvailableComponentsForm/AvailableComponentsForm.props';
import { ComponentConfigurationForm } from '../../forms/ComponentConfigurationForm/ComponentConfigurationForm';
import { ComponentConfigurationFormProps } from '../../forms/ComponentConfigurationForm/ComponentConfigurationForm.props';

/**
 * The steps required to support the Add to set process.
 */

export const getAddComponentToSetSteps = (props: AddComponentToSetProps): Array<WizardStep> => {
  const { webpath, componentSetDisplayName, updateComponentSetDetails } = props;

  // Step 1
  const availableComponents = {
    renderStep: (props: WizardStepProps): JSX.Element => {
      const customProps: AvailableComponentsFormProps = {
        componentSetDisplayName,
        componentSetWebpath: webpath,
        ...props,
      };
      return <AvailableComponentsForm {...customProps} />;
    },
  };

  // Step 2
  const componentConfiguration = {
    renderStep: (wizardProps: WizardStepProps): JSX.Element => {
      const customProps: ComponentConfigurationFormProps = {
        updateComponentSetDetails,
        webpath,
        ...wizardProps,
        submitButtonText: props.submitButtonText,
      };
      return <ComponentConfigurationForm {...customProps} />;
    },
  };

  return [availableComponents, componentConfiguration];
};
